import * as React from "react";
import "./DocumentOverlayContentComponent.css";
import { Dialog, Intent, Spinner } from "@blueprintjs/core";
import { HRAppTemporaryDocument } from "../../messages/HR";
import { PlaceholderEmbeddedPDF } from "../placeholders/PlaceholderEmbeddedPDF";
import { Loading, isLoading } from "../../Loading";

interface DocumentOverlayContentComponentProps {
    tempPdf: HRAppTemporaryDocument | Loading;
    onConfirmClick: () => void;
    onCancelClick: () => void;
}

export class DocumentOverlayContentComponent extends React.Component<DocumentOverlayContentComponentProps> {
    constructor(props: DocumentOverlayContentComponentProps) {
        super(props);
    }

    render() {
        return (
            <Dialog
                isOpen={true}
                onClose={this.props.onCancelClick}
                title={isLoading(this.props.tempPdf) ? "Loading..." : "Please read and confirm"}
                className={"DocumentOverlayContentComponent_dialog"}
            >
                {isLoading(this.props.tempPdf) ?
                    <div className={"DocumentOverlayContentComponent_loadingContainer"}>
                        <Spinner intent={Intent.PRIMARY} className={"DocumentOverlayContentComponent_loadingSpinner"}/>
                        <button className={"btn btn-default btn-xl"} onClick={this.props.onCancelClick}>Cancel</button>
                    </div>
                    : (
                        <div id={"DocumentOverlayContentComponentPdfContainer"}>
                            <div className={"DocumentOverlayContentComponent_pdfContainer"}>
                                <PlaceholderEmbeddedPDF
                                    pdfUrl={this.props.tempPdf.url}
                                    containerElementId={"DocumentOverlayContentComponentPdfContainer"}
                                />
                            </div>
                            <div className={"DocumentOverlayContentComponent_buttonsContainer"}>
                                <button className={"btn btn-default btn-xl"} onClick={this.props.onCancelClick}>Edit</button>
                                <button className={"btn btn-primary btn-xl"} onClick={this.props.onConfirmClick}>Confirm</button>
                            </div>
                        </div>
                    )
                }
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/DocumentOverlayContentComponent.tsx